import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Link } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
import _isEmpty from 'lodash/isEmpty';
import { generateLinkData, trackActivityEvent, trackClickEvent } from '../helpers/analytics/fptiHelper';
import { CONTACT_CALL_US, CONTACT_TOPIC_TREE_INTENTS, LOCATION } from '../common/storeConstants';
import { FPTI_DATA } from '../common/propTypes';
import { resetCallUsInfo } from '../components/callUsComponent/CallUs-Actions';
import { getHomeURL } from '../helpers/twHelper';
import { pageNames } from '../common/constants';
import { redirectLocation } from '../../js/contactUs/actions/action-contact-location';

const buttonType = {
  CONTACT_US: 'contactUs',
  HELP: 'help',
};

const BackButton = function (props) {
  const { pageName } = useSelector((state) => state[LOCATION]);
  const { callUsInfo } = useSelector((state) => state[CONTACT_CALL_US]);
  const { isLoading: isLoadingIntents } = useSelector((state) => state[CONTACT_TOPIC_TREE_INTENTS]);

  // if not back to Contact, then back to Help
  const [backButtonShown, setBackButtonShown] = useState(true);
  const [btnType, setBtnType] = useState(buttonType.HELP);
  const dispatch = useDispatch();

  const { FPTIData } = props;

  const handleBackButtonFPTIEvent = (button) => {
    const fptiData = {
      ...FPTIData.heroBackButtonShown,
      link: generateLinkData(FPTIData.heroBackButtonShown.link, { btnType: button }),
      event_name: generateLinkData(FPTIData.heroBackButtonShown.event_name, { btnType: button }),
    };
    trackActivityEvent(fptiData);
  };

  // fire back button FPTI event
  // callUsInfo -> call page page -> contact us back button
  // !callUsInfo && contact us page -> contact us page -> help back button
  useEffect(() => {
    // only display back button when we finish loading the priority intents
    if (!isLoadingIntents) {
      if (!_isEmpty(callUsInfo)) return handleBackButtonFPTIEvent(buttonType.CONTACT_US);
      if (pageName && pageName !== pageNames.CALL_US) return handleBackButtonFPTIEvent(buttonType.HELP);
    }
    return null;
  }, [callUsInfo, pageName, isLoadingIntents]);

  const handleButtonInDifferentPages = (button) => {
    setBackButtonShown(true);
    setBtnType(button);
  };

  // TODO: add other page dependencies e.g, community, message when they are available
  useEffect(() => {
    if (!pageName) return;
    switch (pageName) {
      case pageNames.CALL_US:
        handleButtonInDifferentPages(buttonType.CONTACT_US);
        break;
      default:
        handleButtonInDifferentPages(buttonType.HELP);
        break;
    }
  }, [pageName]);

  const handleCallUsPageClickBackButton = () => {
    dispatch(redirectLocation({ pageName: pageNames.CONTACT_US }));
    dispatch(resetCallUsInfo());

    // Chatbot service deprecated - removed postChatBotEligibility call
  };

  // TODO: add reset action and redirect action for other pages when other pages are available when click the back to Contact button
  // if page is callUs, then clicking button redirect to Contact us page
  // default is redirect to Help center page
  const handleBackButtonClickEvent = (e) => {
    e.preventDefault();
    const fptiData = {
      ...FPTIData.heroBackButtonClick,
      link: generateLinkData(FPTIData.heroBackButtonClick.link, { btnType }),
      event_name: generateLinkData(FPTIData.heroBackButtonClick.event_name, { btnType }),
    };
    trackClickEvent(fptiData);

    switch (pageName) {
      // redirect to contactUs
      case pageNames.CALL_US:
        handleCallUsPageClickBackButton();
        break;
      default:
        // redirect to Home page
        window.open(getHomeURL(), '_self');
        break;
    }
  };

  const renderBtnTextContent = () => {
    if (btnType === buttonType.CONTACT_US) return <Message id="smarthelp.app.hero.header.label.button.contact" />;
    return <Message id="smarthelp.app.hero.header.label.button.help" />;
  };

  const renderBackButton = () => {
    return (
      <Link
        className="sh_hero__panel__back_button_link"
        data-testid="sh-hero-panel-back-button-link"
        onClick={(e) => handleBackButtonClickEvent(e)}
      >
        <Icon name="arrow-left" className="sh_hero__panel__back_button" data-testid="sh-hero-panel-back-button" />
        <p className="sh_hero__panel__back_button_text" data-testid="sh-hero-panel-back-button-text">
          {renderBtnTextContent()}
        </p>
      </Link>
    );
  };

  if (!backButtonShown) return null;

  return (
    <button className="sh_hero__panel__back_button_container" data-testid="sh-hero-panel-back-button-container">
      {renderBackButton()}
    </button>
  );
};

BackButton.propTypes = {
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
};

export default BackButton;
